// src/pages/Login.js
import React, { useEffect, useState } from "react";
import {
  browserLocalPersistence,
  setPersistence,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { Link, useNavigate } from "react-router-dom";
import { auth, db, get } from "../../utilities/firebaseConfig";
import { ref } from "firebase/database";
import loginbg from "../../assets/loginbg.jpg";
import { Eye, EyeOff } from "lucide-react";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSignIn = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setErrorMessage("All fields are required");
      return;
    }

    try {
      await setPersistence(auth, browserLocalPersistence); // ✅ Set persistence
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;

      if (!user) {
        setErrorMessage("Authentication failed. Please try again.");
        return;
      }

      if (!user.emailVerified) {
        setErrorMessage("Please verify your email before logging in. ");
        navigate("/verify-email");
      } else {
        // Check if the user is a technician
        const technicianRef = ref(db, `technicians/${user.uid}`);
        const technicianSnapshot = await get(technicianRef);

        if (technicianSnapshot.exists()) {
          navigate("/technician/dashboard");

          // All steps completed
        }

        // Check if the user is a regular user
        const userRef = ref(db, `users/${user.uid}`);
        const userSnapshot = await get(userRef);

        if (userSnapshot.exists()) {
          navigate("/client/dashboard");
        } else {
          setError("User not found. Please sign up.");
        }
      }
    } catch (error) {
      setErrorMessage(error.message);
    }
  };

  const [openMenu, setOpenMenu] = useState(true);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setIsVisible(currentScrollY < lastScrollY);
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <div className='authbody'>
      <div className='authspagecnt'>
        <div className='signin_cnt'>
          <Link to='/' className='profixlogo'>
            ProfixExpress
          </Link>
          <div className='signincntbdy'>
            <h2 className='signin_title'>Login in to Profixexpress</h2>
            <div className='thespace'></div>
            <p className='dnthaacnt'>
              Don't have an account?{" "}
              <span onClick={() => navigate("/client/signup")}>Signup</span>
            </p>
            <div className='thespacee'></div>
            {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
            <div className='thespacee'></div>
            <form onSubmit={handleSignIn} className='theformcnt'>
              <div className='inputcnt'>
                <input
                  type='email'
                  placeholder='Email'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className='inputcnt' style={{ position: "relative" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder='Password'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  style={{
                    width: "100%",
                    paddingRight: "40px", // leave space for the icon
                  }}
                />
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#666",
                  }}
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </span>
              </div>
              <p
                className='forgotpassworkclick'
                onClick={() => navigate("/forgot-password")}
              >
                Forgot Password?
              </p>
              <div className='thespacee'></div>
              <button className='thesigninbtn' type='submit'>
                Login
              </button>
            </form>
          </div>
        </div>
        <div className='signinimagecnt'>
          <img className='signiimg' src={loginbg} alt='' />
        </div>
      </div>
    </div>
  );
};

export default Login;
